import React from 'react';
import { siteData } from '../data/mock';

const Approach = () => {
  const { approach } = siteData;
  
  return (
    <article className="space-y-14 sm:space-y-20">
      {/* Header */}
      <header className="space-y-3 sm:space-y-4">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-light text-[#1a1a1a] leading-snug sm:leading-tight tracking-tight">
          {approach.title}
        </h1>
        <p className="text-base sm:text-lg text-[#4a4a4a]">
          {approach.subtitle}
        </p>
      </header>
      
      {/* Why an Execution OS */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {approach.why.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {approach.why.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* What the Execution OS Is */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {approach.what.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {approach.what.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
      
      {/* How the Execution OS Works */}
      <section className="space-y-6 sm:space-y-8">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {approach.how.title}
        </h2>
        <div className="space-y-6 sm:space-y-8">
          {approach.how.steps.map((step, i) => (
            <div key={i} className="space-y-2">
              <h3 className="text-[#1a1a1a] text-base font-medium">
                {step.number}. {step.title}
              </h3>
              <p className="text-[#2a2a2a] text-base leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </section>
      
      {/* What Makes This Different */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {approach.different.title}
        </h2>
        <ul className="space-y-2.5 sm:space-y-2 text-[#2a2a2a] text-base leading-relaxed">
          {approach.different.points.map((point, i) => (
            <li key={i} className="flex">
              <span className="mr-3 text-[#999999] flex-shrink-0">—</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </section>
      
      {/* Commercial Architecture for Infrastructure Platforms */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {approach.infrastructureArchitecture.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {approach.infrastructureArchitecture.intro.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        
        {/* The Commercial Architecture Layer */}
        <div className="pt-4 sm:pt-6 space-y-5 sm:space-y-6">
          <h3 className="text-[#1a1a1a] text-base font-medium">
            {approach.infrastructureArchitecture.subheading}
          </h3>
          <p className="text-[#2a2a2a] text-base leading-relaxed">
            {approach.infrastructureArchitecture.subheadingIntro}
          </p>
          
          {/* Four Architecture Domains */}
          <div className="space-y-6 sm:space-y-8 pt-2">
            {approach.infrastructureArchitecture.domains.map((domain, i) => (
              <div key={i} className="space-y-2">
                <h4 className="text-[#1a1a1a] text-base font-medium">
                  {domain.title}
                </h4>
                <p className="text-[#2a2a2a] text-base leading-relaxed">
                  {domain.description}
                </p>
                <p className="text-[#2a2a2a] text-base leading-relaxed">
                  {domain.examples}
                </p>
              </div>
            ))}
          </div>
          
          {/* Closing */}
          <div className="space-y-1 text-[#2a2a2a] text-base leading-relaxed pt-4 sm:pt-6">
            {approach.infrastructureArchitecture.closing.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </section>
      
      {/* Closing Thought */}
      <section className="space-y-5 sm:space-y-6">
        <h2 className="text-xs uppercase tracking-widest text-[#999999] font-medium">
          {approach.closing.title}
        </h2>
        <div className="space-y-4 text-[#2a2a2a] text-base leading-relaxed">
          {approach.closing.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>
    </article>
  );
};

export default Approach;
